import React from 'react';
import Icon from '../../../components/AppIcon';
import Image from '../../../components/AppImage';

const PersonalRecordCard = ({ 
  exercise, 
  record, 
  unit = 'lbs',
  date,
  improvement,
  image,
  imageAlt
}) => {
  return (
    <div className="bg-card border border-border rounded-lg overflow-hidden shadow-md hover-lift transition-smooth">
      <div className="relative h-32 md:h-40 overflow-hidden bg-muted">
        <Image 
          src={image}
          alt={imageAlt}
          className="w-full h-full object-cover"
        />
        <div className="absolute top-2 right-2 flex items-center gap-1 bg-accent text-accent-foreground px-2 py-1 rounded-full">
          <Icon name="Award" size={14} />
          <span className="text-xs font-semibold">PR</span>
        </div>
      </div>

      <div className="p-4">
        <h4 className="text-base md:text-lg font-heading font-semibold text-foreground mb-2">
          {exercise}
        </h4>
        
        <div className="flex items-baseline gap-2 mb-3">
          <span className="text-2xl md:text-3xl font-heading font-bold text-accent data-text">
            {record}
          </span>
          <span className="text-sm md:text-base text-muted-foreground">{unit}</span>
        </div>

        <div className="flex items-center justify-between text-xs md:text-sm">
          <div className="flex items-center gap-1 text-muted-foreground">
            <Icon name="Calendar" size={14} />
            <span className="caption">{date}</span>
          </div>
          {improvement && (
            <div className="flex items-center gap-1 text-success">
              <Icon name="TrendingUp" size={14} />
              <span className="font-semibold data-text">+{improvement}</span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default PersonalRecordCard;